import type { ICharacter, PageRowViewModel } from "@next-platform/client-common-core";

/**
 * Drops the chatbots the viewer asked to see less of; hands back the same row when nothing changes so memoized consumers stay put.
 * A row left without items collapses to `empty` so the section title goes with its cards.
 */
const hideDismissedDiscoverCharacters = (
  row: PageRowViewModel<ICharacter> | undefined,
  dismissedCharacterIds: readonly string[],
): PageRowViewModel<ICharacter> | undefined => {
  if (row?.status !== "success" || dismissedCharacterIds.length === 0) {
    return row;
  }

  const items = row.items.filter((character) => !dismissedCharacterIds.includes(character.character_id || character.id));

  if (items.length === row.items.length) {
    return row;
  }

  return items.length === 0 ? { status: "empty", block: row.block } : { ...row, items };
};

export default hideDismissedDiscoverCharacters;
